<db-card>
  <div>
    <db-loader
      [isLoading]="isLoading"
      loaderText="We're getting your company ready"
      [noShadow]="true"
    ></db-loader>
  </div>
</db-card>
